import { get } from 'lodash';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { graphqlify } from 'Utils/graphql';
import {
  getPaymentScheduleRequest,
  getPriceDetailFragment,
  proposalPriceQuery,
} from 'Utils/graphql-query-helper/booking/proposal/proposalQuery';
import { PROPOSAL_UPDATE_ATTENDEES } from 'Utils/request/requestDictionary';
import { removeUselessProperties } from './attendeesUtils';
export type updateAttendeesMutationType = {
  proposalId: string;
  attendees: {
    adults: AdultParticipants;
    children: ChildrenParticipants;
  };
  appContext: AppContext;
};

/**
 * Connected customer experience : Put attendees
 */
function updateAttendeesMutation({
  proposalId,
  attendees,
  appContext,
}: updateAttendeesMutationType): Promise<any> {
  const adults = attendees.adults.map(removeUselessProperties);
  const children = attendees.children.map(removeUselessProperties);
  return graphQLClient.runNoCacheQuery(
    `
    mutation {
      modifyAttendees (
        proposalId: "${proposalId}",
        adults: ${graphqlify(adults)},
        children: ${graphqlify(children)}
        ) {
        proposal {
          id
          attendees {
            list {
              id
              customerId
              civility
              firstName
              lastName
              birthdate
              email
              optins {
                channel
                optin
              }
            }
          }
          households {
            attendees {
              id
              customerId
              birthdate
              isAdult
              isMain
            }
            ${getPaymentScheduleRequest(appContext)}
          }
          ${proposalPriceQuery()}
        }
        errors {
          concernedAttendees
          errorKey
          errorValue
          errorCode
          errorDescription
        }
        attendees {
          id
          ${appContext.isSeller ? 'gmNumber' : ''}
          customerId
          customerType
        }
      }
    }
    ${getPriceDetailFragment(get(appContext, 'locale'))}
    `,
    appContext,
    {
      requestName: PROPOSAL_UPDATE_ATTENDEES,
    },
  );
}

const queryBookingAttendees = (bookingId: string) => {
  return graphQLClient.runQuery(`query {
    bookingAttendees(bookingId: ${bookingId}) {
      civility
      gmNumber
      customerId
      identityNumber
      healthPassId
      mainContact
      lastName
      unicodeLastName
      firstName
      unicodeFirstName
      email
      birthdate
    }
  }`);
};

export { updateAttendeesMutation, queryBookingAttendees };
